import React, {Fragment, useEffect } from "react";
import { 
    Box, Button, Divider,
    Badge 
} from "@mui/material";

// routing 
import { useNavigate } from "react-router-dom";

// helper functions
import { englishToMyanmarNumber } from '../../../helpers/EngNumberToMyanmar';
// loding screen
import AudioCategoryListLoading from "../../../components/skeletonLoading/audioCategoryListLoading/AudioCategoryListLoading";
/*** api ***/
import { useFetchAudioCategoryListDataQuery } from "../../../api/audioCategroyListPageApi";
import Rabbit from "rabbit-node/lib/rabbit";

import { NotFound } from "../../error/NotFound_404";

const Index = () => {
    const navigate = useNavigate();
  const { data, error, isLoading, isFetching } =
    useFetchAudioCategoryListDataQuery();

  if (isLoading) {
    return <AudioCategoryListLoading />;
  }

  if (error) {
    return <NotFound error={error} />
  }

  return (
    <Box>
      {data.status &&
        data &&
        data.result.map((item, index) => (
          <Fragment key={index}>
            <div  className="py-4 flex justify-between" 
            onClick={() => navigate(`/audio/books-by-category/${item.category_id}`)}
            >
              <Button variant="default">
                <span className="text-sm">{Rabbit.zg2uni(item.name)}</span>
            </Button>
              <Badge
                // badgeContent={numberToDisplay}
                color="secondary"
                overlap="circular"
                className="mr-4"
              >
                {/* <div
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    background: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "black",
                    float: "right",
                  }}
                  className="text-xs"
                >
                    {englishToMyanmarNumber(item.book_count)}
                </div> */}
              </Badge>
              
            </div>
            <Divider variant="middle" sx={{ backgroundColor: "#52525b" }} />
          </Fragment>
        ))}
    </Box>
  );
};

export default Index;
